<template>
  <v-card class="overflow-hidden v-card v-sheet theme--light ma-0">
    <div>
      <v-alert :type="alert_type" :model-value="alert" :value="alert" transition="scale-transition">{{ alert_message }}</v-alert>
    </div>
    <v-snackbar v-model="snackbar.visible" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'"
      :timeout="snackbar.timeout" :location="snackbar.position === 'top' ? 'top' : 'bottom'">
      <v-layout align-center pr-4>
        <v-icon class="pr-3 ml-2" dark large>{{ snackbar.icon }}</v-icon>
        <v-layout column>
          <div>{{ snackbar.text }}</div>
        </v-layout>
      </v-layout>
      <v-btn v-if="snackbar.timeout === 0" icon @click="snackbar.visible = false">
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>
    <!-- Title-->
     <div>
       <HeaderComponent :headerTitle="headerText" />
     </div>
    <div id="printable-barcode-area" style="display: none;"></div>
    <!-- Request tracker tab popups -->
    <v-row justify="center">
      <v-dialog v-model="dialogDetails" persistent max-width="700px">
        <v-card class="v-card-100">
          <v-card class="v-card-100 mt-0 custom-shadow">
            <v-card-title class="pa-0">
              <v-row class="ma-1 ml-3">
              <span style="font-weight: 600;">Generate Tag ID</span>
              <v-spacer></v-spacer>
                <v-icon @click="dialogDetailsClose">mdi-close</v-icon>
            </v-row>
            </v-card-title>
            </v-card>
          <v-form>
            <v-card-text>
              <v-container>
                <v-row v-for="(item, index) in tag_numbers" :key="index" justify="center">
                  <v-col cols="6">
                    <label>Total Quantity: {{ item.quantity }}</label>
                    <v-autocomplete v-model="item.location" :items="getFilteredLocationItems(index)" item-title="code" item-value="id" return-object
                      label="Location" @change="updateCode(index)"  variant="outlined">
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="6" class="mt-7">
                    <v-btn color="primary" size="small" variant="outlined" v-if="index === tag_numbers.length - 1 && tag_numbers.length > 1" style="position: absolute;right: 30px;bottom: 80px;" @click="cancelField(index)">Cancel</v-btn>
                    <v-text-field v-model="item.quantity" label="Quantity" :rules="[numberRule]" type="number" min="1" required variant="outlined"></v-text-field>
                  </v-col>
                </v-row>
                <a style="color:#0357D0;margin-top: -20px;position: absolute;" @click="addField"><u>Add</u></a>
              </v-container>
            </v-card-text>
          </v-form>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn variant="outlined" x-large color="primary" class="cancel-color mb-3 text-none"
              @click="dialogDetailsClose">Cancel</v-btn>
            <v-btn color="primary" x-large class="mb-3 text-none" variant="flat" :disabled="isSubmitDisabled"
              @click="requestSubmission">Generate</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row justify="center">
      <v-dialog v-model="assign_user_popup" persistent max-width="400px">
        <v-card class="v-card-100">
          <v-card class="v-card-100 mt-0 custom-shadow">
            <v-card-title class="pa-1">
              <v-row class="ma-1">
              <span style="font-weight: 600;">Assign Tag ID</span>
              <v-spacer></v-spacer>
                <v-icon @click="assign_user_popup = false">mdi-close</v-icon>
            </v-row>
            </v-card-title>
            </v-card>
          <v-form>
            <v-card-text>
              <v-container>
                <v-autocomplete v-model="selected_user_id" :items="users" label="Assign To" item-title="username" item-value="id"  variant="outlined"/>
              </v-container>
            </v-card-text>
          </v-form>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn variant="outlined" x-large color="primary" class="cancel-color mb-3 text-none"
              @click="assign_user_popup = false">Cancel</v-btn>
            <v-btn color="primary" x-large class="mb-3 text-none" variant="flat" :disabled="!selected_user_id"
              @click="assigenTagToUser">Submit</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row justify="center">
      <v-dialog v-model="deactivate_popup" persistent max-width="700px">
        <v-card class="v-card-100">
          <v-card class="v-card-100 mt-0 custom-shadow">
            <v-card-title class="pa-1">
              <v-row class="ma-1">
              <span style="font-weight: 600;">Balance Tag IDs</span>
              <v-spacer></v-spacer>
                <v-icon @click="deactivate_popup = false">mdi-close</v-icon>
            </v-row>
            </v-card-title>
            </v-card>
          <v-form>
            <v-card-text>
              <v-container>
                <v-text-field  prepend-inner-icon="mdi-magnify" v-model="searched_tag_ids" label="Search Tag IDs" variant="outlined" @keydown.enter.prevent="callBalancedTagIds"></v-text-field>
                <div class="selected_balance_count_css"> Selected ({{ selected_tag_ids.length }})</div>
                <v-row class="mt-4">
                  <v-col cols="2" v-for="(item, index) in balanced_tag_ids" :key="index">
                    <div class="pa-2" :class="selected_tag_ids.includes(item) ? 'selected_tag_css' : 'unselected_tag_css'" @click="selected_tag_ids.includes(item) ? selected_tag_ids.splice(selected_tag_ids.indexOf(item), 1) : selected_tag_ids.push(item)">
                      {{ item.tag_number }}
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-form>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn variant="outlined" x-large color="primary" class="cancel-color mb-3 text-none"
              @click="deactivate_popup = false">Cancel</v-btn>
            <v-btn color="primary" x-large class="mb-3 text-none" variant="flat" :disabled="!selected_tag_ids.length"
              @click="deactivate_tag_ids">Deactivate</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!--  Success message popup -->
    <v-row justify="center">
      <v-dialog v-model="successpopup" persistent max-width="424px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex">
            <v-spacer></v-spacer>
            <v-btn icon @click="successpopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="text-center">
            <span> {{ successmessage }}</span>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn color="primary" variant="flat" class="mb-3 text-none" @click="afterClickOkLoadData">Ok</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- filter data popup -->
    <v-dialog content-class="filter-style" v-model="filterDetails" persistent
      :max-width="active_tab === `Generated Tag ID's` ? '400px' : '1000px'">
      <v-card>
        <v-card-actions>
          <v-combobox v-model="locationAs" prepend-inner-icon="mdi-magnify"
          :items="location_items" item-title="code" item-value="id" label="Locations" variant="outlined" class="ma-2" :loading="loading"> </v-combobox>
          <v-combobox v-if="active_tab != `Generated Tag ID's`" v-model="assignee_name" prepend-inner-icon="mdi-magnify"
          :items="users" item-title="username" item-value="id" label="Assignee Name" variant="outlined" class="ma-2" :loading="loading"> </v-combobox>
          <v-combobox v-if="active_tab != `Generated Tag ID's` && active_tab != 'Track Tag IDs'" v-model="assignee_code" prepend-inner-icon="mdi-magnify"
          :items="users" item-title="id" item-value="id" label="Assignee Code" variant="outlined" class="ma-2" :loading="loading"> </v-combobox>
          <v-combobox v-if="active_tab != `Generated Tag ID's`" v-model="filtered_batch_number" prepend-inner-icon="mdi-magnify"
          :items="batch_numbers" label="Batch Number" variant="outlined" class="ma-2" :loading="loading"> </v-combobox>
          <v-combobox v-if="active_tab != `Generated Tag ID's`" v-model="filtered_tag_id" prepend-inner-icon="mdi-magnify"
          :items="type_of_tag_ids" label="Type Of Tag ID" variant="outlined" class="ma-2" :loading="loading"> </v-combobox>
          <!-- Request tracker fields -->
          <v-combobox v-if="active_tab === `Generated Tag ID's`" v-model="status_filter" :items="filter_status"
            item-title="name" item-value="id" label="Status"
            variant="outlined"></v-combobox>
          <!-- Track Tag IDs tab filters -->
        </v-card-actions>
        <v-card-actions class="margin-10">
          <v-spacer></v-spacer>
          <v-btn small variant="outlined" text color="normal" class="text-none" @click="filterDetails = false">Cancel</v-btn>
          <v-btn small variant="flat" color="primary" class="text-none" @click="ApplyFilterFunc">Apply Filter(s)</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Track Tag IDs tab popup end-->
    <!-- Tabs -->
    <v-card class="v-card-100">
      <v-tabs v-model="selected_tab">
        <v-tab class="component-tab-heading" ripple :href="'#'" @click="loadData(tab, 'tab_clicked')"
          style="text-transform:none!important;text-decoration: none;" v-for="(tab, index) in tabs" :key="index">
          {{ tab }}
        </v-tab>
      </v-tabs>
    </v-card>
    <!-- Search, Action Buttons, Filter -->
    <generateBoxid v-if="selected_tab == 3" />
    <v-card-title style="display:flex;padding: 25px" class="action-style pb-4" v-if="selected_tab != 3">
      <!-- Search Fields -->
      <v-row>
        <v-col cols="8" sm="8"  class="pb-0">
          <v-text-field prepend-inner-icon="mdi-magnify" v-model="search_tag" v-no-edge-space label="Search" class="search_style"
            variant="outlined" v-on:keyup.enter="loadData(active_tab)"></v-text-field>
        </v-col>
      </v-row>
      <!-- Action Buttons -->
      <v-card-actions v-if="active_tab == `Generated Tag ID's`">
        <v-btn class="mr-2 text-none" variant="flat" size="x-large" color="primary" @click="navigateToFileUpload">
          Upload</v-btn>
        <v-btn class="mr-2 text-none" variant="flat" size="x-large" color="primary" @click="generateTrack">
          Generate</v-btn>
        <v-btn class="mr-2 text-none" variant="flat" size="x-large" color="primary" @click="downloadTrack">
          Download</v-btn>
      </v-card-actions>
      <v-card-actions v-if="active_tab == 'Assign Tag IDs'">
        <v-btn class="mr-2 text-none" variant="flat" size="x-large" color="primary" @click="assign_tag_ids" :disabled="selected.length == 0">
          Assign Tag IDs</v-btn>
      </v-card-actions>
      <!-- Filter -->
      <v-expansion-panels class="custom-control_outlined m-0 pt-2" ref="filterPopupRef" readonly
        style="max-width: 110px; margin-bottom: 28px; height: 52px;">
        <v-expansion-panel variant="outlined" @click="filterListOfButtons">
          <v-expansion-panel-title>Filter
          </v-expansion-panel-title>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card-title>
    <!-- Data Table -->
    <v-layout column  v-if="selected_tab != 3">
      <!-- <v-flex md6 style="overflow: auto"> -->
      <v-data-table density="compact" :search="search" v-model="selected" show-select disable-pagination
        :hide-default-footer="true" :headers="headers" :items-per-page="pageSize" :items="table_data" fixed-header height="100%" :loading="loading"
        loading-text="Loading Data... Please wait" class="elevation-1" return-object>
           <template v-slot:[`item.${header.key}`]="{ item }" v-for="header in headers">
              <span v-if="header.key == 'print' && active_tab == `Generated Tag ID's`">
                <v-btn class="m-2 text-none" color="primary" variant="outlined" @click="updatePrintStatus(item)" style="color: #1976d2;">
                 Print
                </v-btn>
              </span> 
              <span v-else-if="header.key == 'download' && active_tab == `Generated Tag ID's`">
                <v-btn class="m-2 text-none" color="primary" variant="outlined" @click="downloadTrack(item)" style="color: #1976d2;">
                 Download
                </v-btn>
              </span>
              <span v-else-if="header.key == 'completion_timestamp'">
                <span class="m-2 text-none">{{ item.status.charAt(0).toUpperCase() + item.status.slice(1).toLowerCase() }}</span>
              </span> 
              <span v-else-if="header.key !== 'images' && header.key !== 'balanced_tag_ids' && item[header.key]">
                <span v-tooltip="item[header.key]">
                  {{ item[header.key].length > 20 ? item[header.key].slice(0, 20) + '...' : item[header.key] }}
                </span>
              </span>
              <span v-else-if="header.key == 'balanced_tag_ids'">
                <span v-if="item[header.key]" style="color:#0357D0;text-decoration: underline; cursor: pointer;" @click="openDeactivateModal(item)">{{ item[header.key] }}
                </span>
                <span v-else>-</span>
              </span>
              <span v-else>-</span>
            </template>
        <!-- <template #[`item.status`]="{ item }">
          <span class="m-2 text-none">{{ item.status.charAt(0).toUpperCase() + item.status.slice(1).toLowerCase() }}</span>
        </template> -->
        <!-- <template v-if="active_tab == `Generated Tag ID's`" #[`item.print`]="{ item }">
          <v-btn class="m-2 text-none" color="primary" variant="outlined"
            @click="updatePrintStatus(item)" style="color: #1976d2;">
            Print
          </v-btn>
        </template> -->
        <!-- <template v-if="active_tab == `Generated Tag ID's`" v-slot:item.download="{ item }">
          <v-btn class="m-2 text-none" color="primary" variant="outlined" @click="downloadTrack(item)" style="color: #1976d2;">
            Download
          </v-btn>
        </template> -->
        <template #bottom></template>
      </v-data-table>
      <!-- </v-flex> -->
    </v-layout>
    <!-- <div>
      <v-row class="ml-2 pb-0">
        <span class="PaddingItemPerPage d-flex mt-3">
          <label class="" style="margin-top: -2px;">Rows Per Page</label>
          <v-select v-model="pageSize" :items="pageSizes" class="custom-pagination-ui" @update:modelValue="handlePageSizeChange"
            variant="outlined" style="width: 40px;margin-left: 120px;margin-top:-10px;position:absolute;"></v-select>
        </span>
        <span class="item-selected" :style="this.totalCount > 9999 ? 'left:24% !important;' : ''"> <span
            v-if="selected.length == 1">{{ selected.length }} Item Selected</span> <span v-if="selected.length > 1">{{
              selected.length }} Items Selected</span> </span>
        <v-spacer></v-spacer>
        <div class="d-flex">
          <span :class="this.totalCount > 9999 ? 'pt-2 mt-3 mr-1' : 'pt-2 mt-3 mr-1'" v-if="this.totalCount > 0">Showing
            Results {{ (this.page - 1) * this.pageSize + 1 }}
            - {{ Math.min(this.page * this.pageSize, this.totalCount) }} of {{ this.totalCount }}</span>
          <span class="PaddingItemPerPage mr-3" :style="totalPages > 7 ? 'min-width: 380px' : 'auto'">
            <v-pagination v-model="page" :length="totalPages" total-visible="7" class="custom-pagination-ui"
            @update:modelValue="handlePageChange" circle></v-pagination>
          </span>
        </div>
      </v-row>
    </div> -->
    <PaginationComponent  v-if="selected_tab != 3"
                    :pageSize="pageSize"
                    :pageSizes="pageSizes"
                    :totalCount="totalCount"
                    :selected="selected"
                    :page="page"
                    :totalPages="totalPages"
                    @update:pageSize="handlePageSizeChange"
                    @update:page="handlePageChange"
                    class="mt-2 mb-0"
                />
  </v-card>
</template>
<script>
import HeaderComponent from "./../../../commoncomponents/HeaderComponent.vue";
import { defaultPageSize, defaultPageSizes } from '@/components/commoncomponents/PaginationComponent.vue';
import generateBoxid from "@/components/api/v2/generateBoxId/generateBoxid.vue";
export default {
  components: {
    HeaderComponent,generateBoxid
  },
  data() {
    return {
      headerText: "Generate & Track Tag IDs",
      tabs: [
        "Generated Tag ID's",
        "Assign Tag IDs",
        "Track Tag IDs",
        "Generate Box ID's",
      ],
      active_tab: "Generated Tag ID's",
      selected: [],
      table_data: [],
      headers: [
        { title: "Request ID", align: "start", sortable: false, key: "request_id" },
        { title: "Creation Date", key: "creation_date" },
        { title: "Status", key: "status" },
        { title: "Assignees", key: "assignees" },
      ],
      details_data: [],
      tag_numbers: [
        {
          location: null,
          code: null,
          quantity: null
        }
      ],
      dialogDetails: false,
      selected_tab : 0,
      loading: true,
      assigneesdetails: false,
      change_status: false,
      select_location: [],
      filterDetails: false,
      vendor_code: [],
      vendor_data: '',
      debit_amount: null,
      add_assignees: [],
      ategory_select: [],
      search_id_names_select: [],
      closed_value: [],
      location_items: [],
      successpopup: false,
      row: [],
      filteredAssignees: [],
      in_progress_value: [],
      search_id_names_items: [],
      status_filter: [],
      delivery_location_search: [],
      category: [],
      category_filter: '',
      brand_filter: '',
      locationAs: null,
      assignee_name: null,
      assignee_code: null,
      filtered_tag_id: null,
      filtered_batch_number: null,
      number: '',
      successmessage: '',
      snackbar: false,
      snackbar: {
        color: null,
        icon: null,
        mode: null,
        position: "top",
        text: null,
        timeout: 7500,
        title: null,
        visible: false
      },
      search_tag: '',
      search: '',
      download: '',
      print: '',
      showSelectedItems: false,
      assignees_assigned: [],
      assignee_details: [],
      filter_status: [
        {
          "name": "Pending",
          "id": "pending"
        },
        {
          "name": "Completed",
          "id": "completed"
        }
      ],
      selected_status: "completed",
      select_id: '',
      priceErrorMessages: '',
      page: 1,
      totalPages: [],
      totalCount: '',
      pageSize: defaultPageSize,
      pageSizes: defaultPageSizes,
      item: '',
      popuppage: 1,
      popuppageSize: 25,
      itemspageSizes: [25, 50, 100],
      popuptotalPages: [],
      alert: false,
      alert_message: '',
      alert_type: '',
      itemStore: '',
      selectednameItems: [],
      assigneeselectitems: [],
      sub_location_id: [],
      sub_location_id_items: [],
      selectedLocationId: [],
      updateSubLocationPopup: false,
      update_Sub_location: [],
      update_Sub_locationItems: [],
      isPartialOptionDisabled: true,
      isFilteringPage: false,
      filterPageNo: 1,
      scanned_items: '',
      short_count: '',
      total_inventories: '',
      barcodepopup: false,
      // tag_numbers: {
      //   tag_id: '',
      //   tag_number: ''
      // },
      quantity: 1,
      assign_user_popup: false,
      selected_user_id: null,
      all_users: [],
      deactivate_popup: false,
      searched_tag_ids: '',
      selected_tag_ids: [],
      tracked_tag_item : [],
      balanced_tag_ids: [],
      batch_numbers: [],
      users: [],
      type_of_tag_ids: []
    }
  },
  async created() {
    const tab = this.$store.state.active_tab
    if(this.tabs.includes(tab)){
      this.loadData(tab);
      this.selected_tab = this.tabs.indexOf(tab)
    } else {
      this.loadData("Generated Tag ID's");
      this.selected_tab = 0
    }
    // this.getAllUsers();
    this.scrollToTop();
    this.get_filter_data()
  },
  watch: {
    search_id_names_select(newValue) {
      if (newValue && newValue.length > 0) {
        this.$nextTick(() => {
          this.$refs.searchClear.internalSearch = '';
        });
      }
    },
    sub_location_id(newValue) {
      if (newValue && newValue.length > 0) {
        this.$nextTick(() => {
          this.$refs.searchLocationIdClear.internalSearch = '';
        });
      }
    },
    vendor_code(newValue) {
      if (newValue && newValue.length > 0) {
        this.$nextTick(() => {
          this.$refs.vendorsearchClear.internalSearch = '';
        });
      }
    },
    add_assignees(newValue) {
      if (newValue && newValue.length > 0) {
        this.$nextTick(() => {
          this.$refs.assigneesearch.internalSearch = '';
        });
      }
    },
  },
  computed: {
    // selectednameItems() {
    //   return this.search_id_names_select;
    // },
    submitButtonDisabled() {
      if (!this.showDebitNote && !this.showWithoutDebitNote) {
        return true;
      }
      if (this.showDebitNote && (!this.vendor_code || !this.debit_amount)) {
        return true;
      }
      return false;
    },
    isSubmitDisabled() {
      if (this.selectedOption === 'partial' && (!this.sub_location_id || !this.select_location || !this.search_id_names_select)) {
        return true;
      }
      if (this.selectedOption === 'all_invetory' && (!this.select_location || !this.search_id_names_select)) {
        return true;
      }
      for (let item of this.tag_numbers) {
        if (item.quantity === null || item.quantity === undefined || item.quantity === '' || item.quantity <= 0) {
          return true;
        }
      }
      return false;
    },
    
    formattedDebitAmount: {
      get() {
        return (this.debit_amount).toLocaleString('en-IN');
      },
      set(value) {
        const numericValue = Number(value.replace(/[^0-9.-]+/g, ''));
        this.debit_amount = Math.max(parseFloat(numericValue), '');
      }
    },
    selectedLocations() {
      return this.tag_numbers.map(item => item.location).filter(Boolean);
    },
    numberRule() {
      return (value) => {
        if (value === null || value === undefined || value === '') {
          return true;
        }
        if (isNaN(value)) {
          return "This field must be a number";
        }
        if (value <= 0) {
          return "The number must be greater than 0";
        }
        return true;
      };
    },
  },
  methods: {
    loadData(tab, tab_action) {
      if (tab_action) {
        this.search_tag = ''
      }
      this.selected = []
      this.active_tab = tab
      this.table_data = []
      this.page = 1
      this.totalPages = 1
      this.filterPageNo = 1
      this.isFilteringPage = false
      this.$store.commit('setActiveTab',{ 'active_tab' : tab});
      if (tab == "Generated Tag ID's") {
        (this.headers = [
          { title: "Generation/ Upload Date & time", align: "start", key: "generated_at", minWidth: "250px" },
          { title: "Generated/ Uploaded by", key: "username", minWidth: "200px" },
          { title: "Type of Tag ID", key: "type_of_tag_id", minWidth: "200px"},
          { title: "Batch Number", key: "batch_number", minWidth: "200px"},
          { title: "Generated/ Uploaded Quantity", key: "quantity", minWidth: "200px" },
          { title: "Location", key: "distribution_center_name", minWidth: "200px" },
          { title: "Print Status", key: "status", minWidth: "200px" },
          { title: "", key: "print", sortable: false , minWidth: "200px"},
          { title: "", key: "download", sortable: false, minWidth: "200px"},
        ]);
        this.requestData();
      }
      if(tab == "Assign Tag IDs"){
        this.headers = [
          { title: "Location Code", key: "distribution_center_name", minWidth: "200px" },
          { title: "Type Of Tag ID", key: "type_of_tag_id", minWidth: "200px" },
          { title: "Batch Number", key: "batch_number", minWidth: "200px"},
          { title: "Tag ID", key: "tag_number", minWidth: "200px"},
          { title: "Assignee Name", key: "assignee_name", minWidth: "200px"},
          { title: "Assignee Code", key: "assigned_to", minWidth: "200px"},
        ]
        this.getAssignTagIDs();
      }
      if (tab == 'Track Tag IDs') {
        (this.headers = [
          { title: "Location", align: "start", sortable: false, key: "distribution_center_name", minWidth: "200px" },
          { title: "Type of Tag ID", key: "type_of_tag_id", minWidth: "200px"},
          { title: "Batch Number", key: "batch_number", minWidth: "200px"},
          { title: "Assignee", key: "assignee_name", minWidth: "200px"},
          { title: "Total Tag IDs", key: "generated_tag_ids", minWidth: "200px"},
          { title: "Consumded Tag IDs", key: "consumed_tag_ids", minWidth: "200px"},
          { title: "Deactivated Tag IDs", key: "deactivated_quantity", minWidth: "200px"},
          { title: "Balance Tag IDs", key: "balanced_tag_ids", minWidth: "200px"},
        ]);
        this.itemissues();
      }
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    },
    getAssignTagIDs() {
      this.loading = true;
      const searchArray = [];
      if (this.search_tag != '') {
        const parts = this.search_tag.split(',');
        for (let i = 0; i < parts.length; i++) {
          searchArray.push(parts[i]);
        }
      }
      const params = this.getRequestParams(
        this.page,
        this.pageSize
      );
      this.$httpSecured
        .get('/api/v2/tag_number_generation/assigned_tag_numbers', {
          params:
          {
            search: searchArray,
            page: params['page'],
            per_page: params['size'],
          }
        })
        .then(response => {
          if (response.data) {
            this.table_data = response.data.tag_numbers;
            this.totalPages = response.data.meta.total_pages;
            this.totalCount = response.data.meta.total_count;
            this.makeLoadingFalse();
            this.loading = false
          } else {
            this.showAlert("error", "No Data Found");
            this.loading = false;
            this.makeLoadingFalse();
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
          this.makeLoadingFalse();
        });
    },
    requestData() {
      this.loading = true;
      const searchArray = [];
      if (this.search_tag != '') {
        const parts = this.search_tag.split(',');
        for (let i = 0; i < parts.length; i++) {
          searchArray.push(parts[i]);
        }
      }
      const params = this.getRequestParams(
        this.page,
        this.pageSize
      );
      this.$httpSecured
        .get('/api/v2/tag_number_generation', {
          params:
          {
            search: searchArray,
            page: params['page'],
            per_page: params['size'],
          }
        })
        .then(response => {
          if (response.data) {
            this.table_data = response.data.tag_number_generations;
            this.totalPages = response.data.meta.total_pages;
            this.totalCount = response.data.meta.total_count;
            this.makeLoadingFalse();
            this.loading = false
          } else {
            this.showAlert("error", "No Data Found");
            this.loading = false;
            this.makeLoadingFalse();
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
          this.makeLoadingFalse();
        });
    },
    itemissues() {
      this.loading = true;
      const params = this.getRequestParams(
        this.page,
        this.pageSize
      );
      this.$httpSecured
        .get('/api/v2/tag_number_generation/track_tag_numbers', {
          params:
          {
            filter:{
              location: this.search_tag
            },
            page: params['page'],
            per_page: params['size'],
          }
        })
        .then(response => {
          if (response.data) {
            this.table_data = response.data.tag_numbers;
            this.totalPages = response.data.meta.total_pages;
            this.totalCount = response.data.meta.total_count;
            this.makeLoadingFalse();
            this.loading = false
          } else {
            this.showAlert("error", "No Data Found");
            this.loading = false;
            this.makeLoadingFalse();
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
          this.makeLoadingFalse();
        });
    },
    formatStatus(status) {
      if (status === "in_progress") {
        return "In Progress";
      } else if (status === "completed") {
        return "Completed";
      } else if (status === "pending") {
        return "Pending";
      } else if (status === "pending_for_approval") {
        return "Pending For Approval";
      } else if (status === "pending_for_action") {
        return "Pending For Action";
      } else {
        return status;
      }
    },
    formatinventory(inventory_status) {
      if (inventory_status === "short") {
        return "Short";
      } else if (inventory_status === "excess") {
        return "Excess";
      } else {
        return inventory_status;
      }
    },
    assign_tag_ids(){
      this.selected_user_id = null;
      this.assign_user_popup = true
    },
    getAllUsers(){
      this.$httpSecured
      .get('api/v2/users')
      .then(response => {
        this.all_users = response.data.users
      })
      .catch(error => {
        this.showAlert("error", "Something went wrong from Network" + error);
        this.loading = false;
        this.number = 0;          
      })
    },
    assigenTagToUser(){
      this.$httpSecured
      .post("/api/v2/tag_number_generation/assign_to_user", { ids: this.selected.map(x => x.id), user_id:this.selected_user_id  })
      .then(response => {
        this.assign_user_popup = false
        this.successpopup = true;
        this.successmessage = response.data.message
      })
      .catch(error => {
        this.showAlert("error", "Something went wrong from Network" + error);
        this.loading = false;
        this.number = 0;
      })
    },
    downloadTrack(item) {
      let ids = "";
      if (this.selected.length > 0) {
        const ids = this.selected.map(selectedItem => selectedItem.id).join(',');
      } else if (!item) {
        ids = ""
      } else {
        ids = item.id
      }
      const params = {
        ids: ids
      };
      this.$httpSecured
        .get('/api/v2/tag_number_generation/download_tag_numbers', {params: params})
        .then(response => {
          if (response.data) {
            const url = response.data.url;
            const link = document.createElement('a');
            link.href = url;
            link.download = '';
            document.body.appendChild(link);
            link.click();
            this.snackbar = {
              color: "success",
              icon: "mdi-check-circle",
              mode: "multi-line",
              position: "top",
              timeout: 3000,
              title: "Success",
              text: "(CSV File) Downloaded Successfully",
              visible: true
            };
            this.selected = [];
            this.number = 0;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
            this.number = 0;
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
          this.number = 0;
        });
    },
    updateCode(index) {
      const selectedLocation = this.location_items.find(location => location.id === this.tag_numbers[index].location);
      if (selectedLocation) {
        this.tag_numbers[index].code = selectedLocation.code;
      } else {
        this.tag_numbers[index].code = null;
      }
    },
    // create request 
    generateTrack() {
      this.select_location = '';
      this.number = 0;
      this.dialogDetails = true;
    },
    get_filter_data() {
      this.$httpSecured
      .get('/api/v2/tag_number_generation/get_filter_data')
      .then(response => {
        this.location_items = response.data.locations;
        this.users = response.data.users
        this.type_of_tag_ids = response.data.type_of_tag_ids
        this.batch_numbers = response.data.batch_numbers
      })
      .catch(error => {
        console.error("Error fetching brand data:", error);
      });
    },
    navigateToFileUpload() {
      this.$store.commit("setLotIds", {
        lotIds: this.headerText,
        inventoryId: this.headerText,
        action:'first_tab'
      });       
      this.$router.push({ name: "LotFileuploadComm" });
    },
    getFilteredLocationItems(currentIndex) {
      return this.location_items.filter(location => {
        return !this.selectedLocations.includes(location.id) ||
          this.tag_numbers[currentIndex].location === location.id;
      });
    },
    addField() {
      this.tag_numbers.push({ location: null, code: null, quantity: null });
    },
    cancelField(index){
      if (this.tag_numbers.length > 1) {
        this.tag_numbers.splice(index, 1);
      }
    },
    requestSubmission() {
      this.number++;
      const dataToSend = {        
        tag_number_generation: {
          tag_numbers: this.tag_numbers.map(item => {
            return {
              distribution_center_id: item.location.id,
              distribution_center_name: item.location.code,
              quantity: item.quantity
            };
          }).filter(item => item !== null)
        }
      };
      this.$httpSecured
        .post('/api/v2/tag_number_generation', dataToSend)
        .then((response) => {
          if (response.data) {
            this.successpopup = true;
            this.dialogDetails = false;
            this.successmessage = response.data.message;
            this.tag_numbers = [{ location: null, code: null, quantity: null }];
            this.select_location = null;
            this.loadData(this.active_tab);
          } else {
            this.showAlert('error', 'No Data Found');
          }
          this.loading = false;
        })
        .catch((error) => {
          this.$toast.error(error.response.data.error);
          this.loading = false;
        });
    },
    dialogDetailsClose() {
      this.dialogDetails = false;
      this.tag_numbers = [{ location: null, quantity: null }];
    },
    closeassigneepopup() {
      this.assigneesdetails = false;
      this.assigneeselectitems = '';
    },
    ApplyFilterFunc() {
      this.table_data = [];
      this.isFilteringPage = true
      const params = new URLSearchParams();
      this.search_tag = ''
      params.append('page', this.filterPageNo)
      params.append('per_page', this.pageSize)
      if (this.active_tab == "Generated Tag ID's") {
        this.loading = true;
        if(this.status_filter)
        params.append('filter[status]', this.status_filter.id);
        if(this.locationAs)
          params.append('filter[location]', this.locationAs.code);
        this.$httpSecured
          .get('/api/v2/tag_number_generation', { params })
          .then(response => {
            if (response.data) {
              this.table_data = response.data.tag_number_generations;
              this.totalPages = response.data.meta.total_pages
              this.totalCount = response.data.meta.total_count;
              this.filterDetails = false;
              this.loading = false;
              this.status_filter = null;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      } else
      if (this.active_tab === "Track Tag IDs") {
        this.loading = true;
        params.append('filter[location]', this.locationAs ? this.locationAs.code : '');
        params.append('filter[assignee]', this.assignee_name ? this.assignee_name.id : '');
        params.append('filter[type_of_tag_id]', this.filtered_tag_id ? this.filtered_tag_id : '');
        params.append('filter[batch_number]', this.filtered_batch_number ? this.filtered_batch_number : '');

        this.$httpSecured
          .get('/api/v2/tag_number_generation/track_tag_numbers', { params })
          .then(response => {
            if (response.data) {
              this.table_data = response.data.tag_numbers;
              this.totalPages = response.data.meta.total_pages;
              this.totalCount = response.data.meta.total_count;
              this.filterDetails = false;
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      }
      else if(this.active_tab == 'Assign Tag IDs'){
        if(this.locationAs)
          params.append('filter[location]', this.locationAs.code);
        if(this.assignee_name && this.assignee_code){
          params.append('filter[assignee]', ''+this.assignee_name.id+','+this.assignee_code.id);
        } else if(this.assignee_name)
          params.append('filter[assignee]', this.assignee_name.id);
        else if(this.assignee_code)
          params.append('filter[assignee]', this.assignee_code.id);

        if(this.filtered_tag_id)
          params.append('filter[type_of_tag_id]', this.filtered_tag_id);
        if(this.filtered_batch_number)
          params.append('filter[batch_number]', this.filtered_batch_number);
        this.$httpSecured
          .get('/api/v2/tag_number_generation/assigned_tag_numbers', { params })
          .then(response => {
            if (response.data) {
              this.filterDetails = false;
              this.table_data = response.data.tag_numbers;
              this.totalPages = response.data.meta.total_pages;
              this.totalCount = response.data.meta.total_count;
              this.makeLoadingFalse();
              this.loading = false
            } else {
              this.showAlert("error", "No Data Found");
              this.loading = false;
              this.makeLoadingFalse();
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
            this.makeLoadingFalse();
          });
      }
    },
    afterClickOkLoadData() {
      this.successpopup = false;
      this.barcodepopup = false;
      this.assigneesdetails = false;
      this.change_status = false;
      this.dialogDetails = false;
      this.writeoffpopup = false;
      this.updateSubLocationPopup = false;
      this.selected = ''
      this.loadData(this.active_tab);
    },

    requestscreencancel() {
      this.dialogDetails = false;
    },

    updatePrintStatus(item) {
      this.$httpSecured
        .put(`/api/v2/tag_number_generation/${item.id}/print_tag_number`)
        .then(response => {
          if (response.data) {
            // this.successpopup = true;
            // this.successmessage = response.data.message;
            const tagNumbers = response.data.data.tag_numbers;
            this.tag_ids = tagNumbers.map(item => item.id);
            this.barcodeNumbers = tagNumbers.map(item => item.tag_number);
            this.quantity = response.data.data.tag_number_generation.quantity;
            // this.$toast.success(response.data.message);
            this.generateAndPrintBarcodes();
            // this.requestData();
          } else {
            this.showAlert("error", error.response.data.error);
            this.loading = false;
          }
        })
        .catch(error => {
          this.showAlert("error", error.response.data.error);
          this.loading = false;
          this.change_status = false
        });
    },
    
    // generateAndPrintBarcodes(){
    //   const previewWindow = window.open('', 'PRINT', 'height=400,width=600');
    //   previewWindow.document.write('<html><head><title>Barcode Preview</title>');
    //   previewWindow.document.write('<style>');
    //   previewWindow.document.write(`
    //     @media print {
    //       body, html {
    //         width: 2in;
    //         height: 1.5in;
    //         margin: 0;
    //         padding: 0;
    //         display: flex;
    //         align-items: center;
    //         justify-content: center;
    //       }
    //       svg {
    //         max-width: 75%; /* Ensures barcode covers 75% width of the label */
    //       }
    //     }
    //   `);
    //   previewWindow.document.write('</style></head><body>');
    //   // previewWindow.document.write('</head><body>');
    //   console.log(this.tag_ids);

    //   this.tag_ids.forEach((id, index) => {
    //     previewWindow.document.write(`<svg id="code${id}"></svg>`);
    //     JsBarcode(svg, this.barcodeNumbers[index], {
    //       fontSize: 20,
    //       height: 60,
    //       width: 1.5,
    //       margin: 0,
    //       fontOptions: "600"
    //     });
    //   });
    //   previewWindow.document.write('</body></html>');
    //   previewWindow.document.close();
    //   previewWindow.focus();
    //   previewWindow.print();
    // },

  generateAndPrintBarcodes() {
      const previewWindow = window.open('', 'PRINT', 'height=400,width=600');
      previewWindow.document.write('<html><head><title>Barcode Preview</title>');
      previewWindow.document.write('<style>');
      previewWindow.document.write(`
          @media print {
            body, html {
              margin: 0;
              padding: 0;
            }
            canvas {
              display: block;
              margin: auto;
              page-break-after: always; /* Ensures each barcode starts on a new page */
            }
          }
      `);
      previewWindow.document.write('</style></head><body>');

      this.tag_ids.forEach((id, index) => {
          const canvas = document.createElement('canvas');
          JsBarcode(canvas, this.barcodeNumbers[index], {
              fontSize: 20,
              height: 60,
              width: 1.5,
              margin: 0,
              fontOptions: "600",
          });
          previewWindow.document.body.appendChild(canvas);
      });

      previewWindow.document.close();
      previewWindow.focus();
      previewWindow.print();
  },

    filterListOfButtons() {
      document.documentElement.style.setProperty('--dialog-ypos', (this.$refs.filterPopupRef.$el.getBoundingClientRect().top + 40).toString() + 'px');
      this.locationAs = null;
      this.assignee_name = null
      this.assignee_code = null
      this.filtered_tag_id = null
      this.filtered_batch_number = null
      this.status_filter = null;
      this.search_tag = '';
      this.filterDetails = true;
    },

    makeLoadingFalse() {
      setTimeout(() => {
        this.loading = false;
        this.alert = false;
      }, 1500);
    },
    //  pagination params
    getRequestParams(page, pageSize, filterPageNo) {
      let params = {};
      if (page) {
        params["page"] = page;
      }
      if (pageSize) {
        params["size"] = pageSize;
      }
      if (filterPageNo) {
        params["filterPageNo"] = filterPageNo
      }
      return params;
    },
    // To handle the page change
    handlePageChange(value) {
      this.page = value;
      if (this.isFilteringPage) {
        this.filterPageNo = value;
        this.ApplyFilterFunc()
        return;
      }
      if (this.active_tab == "Generated Tag ID's") {
        this.requestData();
      } else if (this.active_tab == 'Track Tag IDs') {
        this.itemissues();
      } else if (this.active_tab == 'Assign Tag IDs') {
        this.getAssignTagIDs();
      }
    },
    //  To handle the page size change
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.page = 1
      this.filterPageNo = 1;
      if (this.isFilteringPage) {
        this.ApplyFilterFunc();
        return;
      }
      if (this.active_tab == "Generated Tag ID's") {
        this.requestData();
      } else if (this.active_tab == 'Track Tag IDs') {
        this.itemissues();
      } else if (this.active_tab == 'Assign Tag IDs') {
        this.getAssignTagIDs();
      }
    },
    showAlert(alert_type, alert_message) {
      this.alert = true;
      this.alert_type = alert_type;
      this.alert_message = alert_message;
      this.makeLoadingFalse();
    },
    openDeactivateModal(item){
      this.searched_tag_ids = ''
      this.selected_tag_ids = []
      this.balanced_tag_ids = []
      this.tracked_tag_item = item
      this.deactivate_popup = true
      this.callBalancedTagIds()
    },
    callBalancedTagIds(){
      const params = new URLSearchParams();
      params.append('page', this.filterPageNo)
      params.append('per_page', this.pageSize)
      params.append('search', this.searched_tag_ids)
      if(this.tracked_tag_item.distribution_center_name)
        params.append('filter[location]', this.tracked_tag_item.distribution_center_name);
      if(this.tracked_tag_item.batch_number)
        params.append('filter[batch_number]', this.tracked_tag_item.batch_number);
      if(this.tracked_tag_item.type_of_tag_id)
        params.append('filter[type_of_tag_id]', this.tracked_tag_item.type_of_tag_id);
      if(this.tracked_tag_item.assignee_id)
        params.append('filter[assignee]', this.tracked_tag_item.assignee_id);
      else params.append('filter[assignee]', 'Unassigned');
      this.$httpSecured
      .get('/api/v2/tag_number_generation/get_balance_tag_ids', { params } )
      .then(response => {
        this.balanced_tag_ids = response.data.tag_numbers
      })
      .catch(error => {
        this.showAlert("error", "Something went wrong from Network" + error);
      });
    },
    deactivate_tag_ids(){
      this.$httpSecured
      .put('/api/v2/tag_number_generation/deactivate_tag_ids', { ids: this.selected_tag_ids.map(x => x.id) } )
      .then(response => {
        this.deactivate_popup = false
        this.successmessage = response.data.message
        this.successpopup = true
      })
      .catch(error => {
        this.showAlert("error", "Something went wrong from Network" + error);
      });
    }
  },
}
</script>
<style scoped>
@media print {
  @page {
    size: auto;
    margin: 0mm;
  }
}
#printable-barcode-area, #printable-barcode-area * {
  visibility: visible;
}
#printable-barcode-area {
  position: absolute;
  left: 0;
  top: 0;
}
.filter_style {
  max-width: 150px;
  margin-bottom: 18px;
  min-height: 52px;
}

.search_style {
  max-width: 300px;
}

.addeditems {
  display: flex;
  float: left;
  padding: 4px;
  border: 1px solid #9e9e9e;
  border-radius: 10px;
  margin: 0px 4px 4px 0px;
}

.closeitems {
  width: 15px !important;
  height: 15px !important;
  margin-top: 4px;
  margin-left: 3px;
}

.status-items {
  font-size: 14px;
  font-weight: 600;
  color: #9c9c9c;
}

.item-selected {
  margin-top: 23px;
  position: absolute;
  left: 41%;
}

@media (max-height: 1104px) {
  .PaddingItemPerPage {
    padding: 8px !important;
  }
}

@media (min-height: 1126px) {
  .PaddingItemPerPage {
    padding: 24px !important;
  }
}

:deep(.radio-styles .v-label) {
  top: 6px !important;
}

.v-data-table {
  height: calc(var(--vh, 1vh) * 100 - 308px) !important;
}

.custom-control_outlined .v-expansion-panel:before {
  box-shadow: none;
}

.custom-control_outlined button {
  min-height: 52px;
  border-width: 1px;
  border-color: rgba(0, 0, 0, .42);
  border-style: solid;
}

.custom-control_outlined button:focus {
  outline: none;
}

.v-dialog:has(.filter-style) {
  justify-content: right;
  align-items: baseline;
  top: var(--dialog-ypos);
}
.selected_balance_count_css{
  color: #1B3A57;
  font-size: 16px;
  font-weight: 600;
  line-height: 100%;
}
.unselected_tag_css{
  border: #C7C8D7 1px solid;
  border-radius: 8px;
  color: #1A1B35;
  font-size: 14px;
  font-weight: 500;
  line-height: 140%;
  width: 100%;
}
.selected_tag_css{
  border: #5A98E1 1px solid;
  border-radius: 8px;
  color: #1A1B35;
  background-color: #E1EEFA;
  font-size: 14px;
  font-weight: 500;
  line-height: 140%;
  width: 100%;
}
/* :deep(.v-data-table thead > tr > th) {
  color: #000 !important;
} */
</style>